import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Locations, LocationsEntity } from "src/app/location/location";
import { Subscription } from "rxjs";
import { MatDialog, MatSnackBar } from "@angular/material";
import { LocationService } from "src/app/location/location.service";

@Component({
  selector: "app-view-location",
  templateUrl: "./view-location.component.html",
  styleUrls: ["./view-location.component.css"],
})
export class ViewLocationComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;

  location: LocationsEntity;

  constructor(
    private route: ActivatedRoute,
    private locationService: LocationService,
    private snackBar: MatSnackBar
  ) {
    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams?.id) {
        this.getLocationById(queryParams.id);
      }
    });
  }

  ngOnInit() {}

  /**
   * Get Equipment Details By Id
   */
  getLocationById(locationId: String | number) {
    this.showLoader = true;
    this.subscription$.add(
      this.locationService
        .getSingleLocation(locationId)
        .subscribe((result: Locations) => {
          if (result?.Loc.length) {
            this.location = result?.Loc[0];
          }
          this.showLoader = false;
        },(error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Location Details. `, "", {
            duration: 2000,
          });
        })
    );
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
